import { AxiosError } from 'axios';
import api from '../../../services/api';
import { FunctionFormProps } from '../types/function.type';

export async function createFunctionRequest({ ...rest }: FunctionFormProps) {
	try {
		const response = await api.post('/function', {
			...rest,
		});

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
